module.exports = __webpack_public_path__ + "img/borderRegularHexagonWhite.45d9818c.svg";